$(function () {
    const viewAsBtnMobile = $(".view-as-btn.mobile");
    const viewAsListMobile = $(".view-as-list.mobile");
    const viewingAsLabel = $(".view-as-list.mobile .viewing-as-label");
    const closeViewAsListButton = $(".view-as-list.mobile .close-dropdown");

    viewAsBtnMobile.on("click", function() {
        viewAsListMobile.toggleClass("active");
        viewingAsLabel.toggleClass("hidden");
    });

    closeViewAsListButton.on("click", function() {
        closeViewAsListButton.parent().removeClass("active");
        viewingAsLabel.addClass("hidden");
    });
});
